import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { COLOR_CODES as t } from "./top-banner-info-constants.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a, renderSlot as o } from "vue";
//#region recipes/notices/top_banner_info/top_banner_info.vue
var s = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeTopBannerInfo",
	props: { colorCode: {
		type: String,
		default: "green300",
		validator: function(e) {
			return t.includes(e);
		}
	} },
	computed: { bannerInfoClass() {
		return [{
			green100: "d-recipe-top-banner-info--positive",
			green300: "d-recipe-top-banner-info--positive",
			red100: "d-recipe-top-banner-info--critical",
			red200: "d-recipe-top-banner-info--critical",
			gold100: "d-recipe-top-banner-info--warning",
			gold200: "d-recipe-top-banner-info--warning",
			black100: "d-recipe-top-banner-info--info",
			white: "d-recipe-top-banner-info--primary"
		}[this.colorCode]];
	} }
}, c = { class: "d-recipe-top-banner-info__left" }, l = {
	class: "d-recipe-top-banner-info__middle",
	"data-qa": "banner-info--middle"
}, u = { class: "d-recipe-top-banner-info__right" };
function d(e, t, s, d, f, p) {
	return a(), n("div", {
		class: i(["d-recipe-top-banner-info", p.bannerInfoClass]),
		"data-qa": "banner-info"
	}, [
		r("div", c, [e.$slots.start ? o(e.$slots, "start", { key: 0 }) : o(e.$slots, "left", { key: 1 })]),
		r("div", l, [o(e.$slots, "default")]),
		r("div", u, [e.$slots.end ? o(e.$slots, "end", { key: 0 }) : o(e.$slots, "right", { key: 1 })])
	], 2);
}
var f = /* @__PURE__ */ e(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=top-banner-info.js.map